import { useEffect, useRef, useState } from "react"
import { addUser } from "../../services/admin/UserService.tsx";
import { useUser } from "../../context/UserContext.tsx";

const RegisterSubAgent = () => {

    const { user: currentUser } = useUser();
    const [formData, setFormData] = useState({username: '', pin: '', parent: ''})
    const [isLoading, setIsLoading] = useState(false);
    const [isSuccess, setIsSuccess] = useState(false);
    const modalRef = useRef<HTMLDivElement | null>(null);
    const [errorMessage, setErrorMessage] = useState<string | null>(null);

    useEffect(() => {
        const modalEl = modalRef.current;
        if (!modalEl) return;

        const handleShow = () => {
            setIsLoading(false);
            setIsSuccess(false);
            setErrorMessage(null);
        };

        const handleHidden = () => {
            setIsLoading(false);
            setIsSuccess(false);
            setErrorMessage(null);
        };

        modalEl.addEventListener('show.bs.modal', handleShow);
        modalEl.addEventListener('hidden.bs.modal', handleHidden);

        return () => {
            modalEl.removeEventListener('show.bs.modal', handleShow);
            modalEl.removeEventListener('hidden.bs.modal', handleHidden);
        };
    }, []);


    const handleInputChange = async (event: any) => {
        const { name, value } = event.target;
        setFormData(prevFormData => ({
            ...prevFormData,
            [name]: value,
        }));
    };

    const handleSubmit = async (e: any) => {
        e.preventDefault();

        if (!formData.username || !formData.pin ) {
            setErrorMessage('Please fill out all fields.');
            return;
        }

        setIsLoading(true);
        setIsSuccess(false);
        setErrorMessage(null);

        const upperUserName = formData.username.toUpperCase();
        const upperPin = formData.pin.toUpperCase();

        const newUser = {
            userName: upperUserName,
            pin: upperPin,
            parent: currentUser!.userName,
            userType: 'subAgent'
        };

        try {
            await addUser(newUser);

            setIsSuccess(true);
            setFormData({
                username: '',
                pin: '',
                parent: '',
            });
        } catch (error: any) {
            setErrorMessage(
                error?.message || 'Something went wrong while creating the sub-agent.'
            );
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div>
            <div className="mt-2 container-fluid">
                <div className="col container-title-addCustomer align-items-center">
                    <span>Add SubAgent</span>
                    <button className="button-agent" data-bs-toggle="modal" data-bs-target="#addCustomrModal">Create</button>
                </div>
                <div className="opcion-add">
                    <div className="row">
                        <div className="col-md-4 col-lg-3 mb-3">
                            <span>Agent Name</span>
                            <input type="text" className="input-agent" name="username" value={formData.username} onChange={handleInputChange} autoComplete="off" required />
                        </div>
                        <div className="col-md-4 col-lg-3 mb-3">
                            <span>Agent Password</span>
                            <input type="text" className="input-agent" name="pin" value={formData.pin} onChange={handleInputChange} required />
                        </div>
                        {/*
                        <div className="col-lg mb-3">
                            <span className="title-form-agent">Under which Master Agent?</span>
                            <input type="search" className="input-agent" name="parent" value={formData.parent || ''} onChange={handleInputChange} autoComplete="parent" required/>
                            {searchResults.length > 0 && (
                                <div className="search-container">
                                    {searchResults.map((user) => (
                                        <div key={user.id} className="search-result" onClick={() => handleResultSelect(user.userName)} >
                                            {user.userName}
                                        </div>
                                    ))}
                                </div>
                            )}
                        </div> */}
                    </div>
                </div>
            </div>

            <div className="modal fade" id="addCustomrModal" tabIndex={-1} ref={modalRef}>
                <div className="modal-dialog">
                    <div className="modal-content">
                        <div className="modal-header">
                            <h5 className="modal-title">
                                {isLoading
                                    ? 'Creating Sub-Agent...'
                                    : isSuccess
                                        ? 'Success'
                                        : 'Are you sure to add a sub-agent?'}
                            </h5>

                            {!isLoading && (
                                <button type="button" className="btn-close" data-bs-dismiss="modal" />
                            )}
                        </div>

                        <div className="modal-body text-center">

                            {errorMessage && !isLoading && (
                                <div className="alert alert-danger text-start">
                                    <strong>Error:</strong> {errorMessage}
                                </div>
                            )}

                            {isLoading && (
                                <>
                                    <div className="spinner-border text-primary mb-3" role="status" />
                                    <p>Creating sub-agent, please wait...</p>
                                </>
                            )}

                            {isSuccess && !isLoading && (
                                <>
                                    <div className="text-success fs-1 mb-3">✔</div>
                                    <p>Sub-agent was created successfully.</p>
                                </>
                            )}

                            {!isLoading && !isSuccess && !errorMessage && (
                                <p>
                                    You are creating an agent. This agent will be able to have players
                                    underneath it but NOT sub-agents.
                                </p>
                            )}
                        </div>


                        <div className="modal-footer">
                            {!isLoading && !isSuccess && (
                                <>
                                    <button className="btn btn-danger" data-bs-dismiss="modal">
                                        Close
                                    </button>
                                    <button
                                        className="btn btn-primary" onClick={handleSubmit}>
                                        Confirm
                                    </button>
                                </>
                            )}

                            {isSuccess && (
                                <button className="btn btn-success" data-bs-dismiss="modal">
                                    Done
                                </button>
                            )}

                        </div>

                    </div>
                </div>
            </div>
        </div>
    );
}
export default RegisterSubAgent;